import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import apiRequest from 'helpers/api';

import { brandApi } from 'api/brands-api';

const initialState = [];

export const getBrands = createAsyncThunk('getBrands', async () => {
  const res = await apiRequest(`brands`, {}, 'get');
  return res.result;
});

export const createBrand = createAsyncThunk('createBrand', async data => {
  const res = await apiRequest('brands', data, 'post');
  return res.result;
});

export const updateBrand = createAsyncThunk('updateBrand', async ({ id, data }) => {
  const res = await apiRequest(`brands/${id}`, data, 'put');
  return res;
});

export const duplicateBrand = createAsyncThunk('duplicateBrand', async ({ id, data }) => {
  const res = await apiRequest(`brands/${id}/duplicate`, data, 'post');
  return res.result;
});

export const deleteBrand = createAsyncThunk('deleteBrand', async id => {
  await apiRequest(`brands/${id}`, {}, 'delete');
  return id;
});

export const getBrandUploads = createAsyncThunk('getBrandUploads', async id => {
  const res = await apiRequest(`brands/${id}/uploads`, {}, 'get');
  return { id, uploads: res.result };
});

const brandsSlice = createSlice({
  name: 'brands',
  initialState,
  reducers: {
    removeBrandUpload(state, { payload }) {
      return state.map(brand => {
        if (brand.id === payload.brandId)
          brand = {
            ...brand,
            uploads: brand.uploads.filter(upload => upload.id !== payload.uploadId),
          };
        return brand;
      });
    },
    addBrandUpload(state, { payload }) {
      return state.map(brand => {
        if (brand.id === payload.brandId)
          brand = { ...brand, uploads: [...brand.uploads, payload.upload] };
        return brand;
      });
    },
  },
  extraReducers: builder => {
    builder
      .addCase(getBrands.fulfilled, (_, { payload }) => {
        return payload;
      })
      .addCase(getBrandUploads.fulfilled, (state, { payload }) => {
        return state.map(brand =>
          brand.id === payload.id ? { ...brand, uploads: payload.uploads } : brand,
        );
      })
      .addCase(createBrand.fulfilled, (state, { payload }) => {
        return [...state, payload];
      })
      .addCase(duplicateBrand.fulfilled, (state, { payload }) => {
        return [...state, payload];
      })
      .addCase(deleteBrand.fulfilled, (state, { payload: id }) => {
        return state.filter(brand => brand.id !== id);
      })
      .addCase(updateBrand.fulfilled, (state, { payload: response }) => {
        if (!response.error) {
          const updatedBrand = response.result;
          return state.map(brand =>
            brand.id === updatedBrand.id ? { ...brand, ...updatedBrand } : brand,
          );
        }
      })
      .addMatcher(
        brandApi.endpoints.updateBrandEmailTemplateLinks.matchFulfilled,
        (state, { payload: updatedBrand }) => {
          return state.map(brand =>
            brand.id === updatedBrand.id ? { ...brand, ...updatedBrand } : brand,
          );
        },
      );
  },
});

export const selectBrands = state => state.brands;

export const { removeBrandUpload, addBrandUpload } = brandsSlice.actions;

export default brandsSlice.reducer;
